import { Component, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("ErrorBoundary caught:", error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      // Note: ErrorBoundary is a class component so cannot use hooks/useTranslation.
      // We detect language from localStorage as a fallback.
      const lang = typeof window !== "undefined" ? localStorage.getItem("i18nextLng") || "es" : "es";
      const isEs = lang.startsWith("es");
      return (
        <div className="min-h-screen flex items-center justify-center bg-background text-foreground p-8">
          <div className="text-center max-w-md space-y-4">
            <h1 className="text-4xl font-bold">Oops</h1>
            <p className="text-muted-foreground">
              {isEs ? "Algo salió mal. Recarga la página para continuar." : "Something went wrong. Reload the page to continue."}
            </p>
            <button
              onClick={() => window.location.reload()}
              className="inline-flex items-center justify-center rounded-lg bg-primary text-primary-foreground px-6 py-3 text-sm font-medium hover:bg-primary/90 transition-colors"
            >
              {isEs ? "Recargar página" : "Reload page"}
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
